import { useTranslation } from 'next-i18next';

import React from 'react';

export const UrgentMessage: React.FC<unknown> = () => {
  const { t } = useTranslation('category/categoryPage');

  return (
    <div
      className="p-6 my-2 text-sm text-white bg-igus-info"
      data-testid="urgent-message"
      dangerouslySetInnerHTML={{
        __html: t('PRODUCT_OVERVIEW.URGENT_MESSAGE'),
      }}
    />
  );
};
